export const YEAR_OPTIONS = [
  { value: 'next', label: 'Próximo año' },
  { value: 'current', label: 'Año actual' },
  { value: 'last2', label: 'Últimos 2 años' },
  { value: 'last5', label: 'Últimos 5 años' },
  { value: 'last10', label: 'Últimos 10 años' },
];
